import {isEmpty} from 'lodash';
import {useCallback, useEffect, useRef} from 'react';

const MAX_CHECKS_COUNT = 10;
type Props = {
    children: React.ReactNode;
} & React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

export const Form: React.FC<Props> = ({children, ...props}: Props) => {
    const formRef = useRef(null);

    const triggerChangeEvent = useCallback((element) => {
        const event = new Event('focus');
        element.dispatchEvent(event);
    }, []);

    useEffect(() => {
        let checksCount = MAX_CHECKS_COUNT;
        let found = false;
        const intervalId = setInterval(() => {
            checksCount--;
            if (!checksCount || found) {
                clearInterval(intervalId);
                return;
            }
            const autoFilledInputs = formRef.current?.querySelectorAll('input:-webkit-autofill');
            if (!isEmpty(autoFilledInputs)) {
                found = true;
                autoFilledInputs.forEach((input) => {
                    triggerChangeEvent(input);
                });
            }
        }, 100);
    }, [formRef, triggerChangeEvent]);

    return (
        <form ref={formRef} {...props}>
            {children}
        </form>
    );
};